/**
 * This is copied nearly-verbatim from
 * emergency_data/src/components/JurisdictionView/Map/hooks/useGISToken.js But
 * that is inaccessible for import from this MFE, and couldn't be typed to match
 * this redux context even if it were.
 */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchGISServices } from '@rsos/reduxDataStore';
import checkGISServicesAccess from '@rsos/utils/checkGISServicesAccess';
import { AdminDispatch } from '../../../../app/store';
import type { AdminState } from '../../../../reducers';

/**
 * A GIS token hook if the agency has GIS services capability enabled
 */
const useGISToken = () => {
  const dispatch: AdminDispatch = useDispatch();

  const orgName = useSelector<AdminState, string | undefined>(
    state => state.sinatra.user.currentOrg?.name,
  );
  if (!orgName) {
    throw Error('Cannot fetch GIS services without valid organization');
  }

  const hasGISServicesAccess = useSelector<AdminState>(checkGISServicesAccess);

  // Fetch GIS services on load
  useEffect(() => {
    if (hasGISServicesAccess) {
      dispatch(fetchGISServices({ orgName, shouldLoadLayers: false }));
    }
  }, [dispatch, hasGISServicesAccess, orgName]);
};

export default useGISToken;
